import React, { useRef } from 'react';

function SearchExpandable({ handleSearch, searchValue, placeholder }) {
  const expandSearchRefBin = useRef(null);
  const handleIconBinClick = () => {
    // Add a class to the input on icon click
    expandSearchRefBin.current.classList.toggle('active-input');
  };
  return (
    <div ref={expandSearchRefBin} className="common-expand-search">
      <button type="button" onClick={handleIconBinClick} className="btn btn-toggle">
        <span className="sr-only">Search</span>
        <span className="icon-Magnifying-Glass-Solid" />
      </button>

      <input type="text" className="form-control" onChange={handleSearch} value={searchValue} autoComplete="off" placeholder={placeholder} />
    </div>
  );
}
export default SearchExpandable;
